var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".player_svg__cls-1{fill:#e8eaeb}.player_svg__cls-2{fill:#fff;stroke:#1a2e3b;stroke-miterlimit:10;stroke-width:2px;stroke-linecap:square}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "player_svg__Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "player_svg__Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "player_svg__cls-1",
    cx: 30,
    cy: 30,
    r: 30
  }), /*#__PURE__*/React.createElement("path", {
    className: "player_svg__cls-2",
    d: "M19 33h-1.14A4 4 0 0010 34h-.5A2.5 2.5 0 007 36.5 2.5 2.5 0 009.5 39H19a3 3 0 003-3 3 3 0 00-3-3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "player_svg__cls-1",
    d: "M15 21h30v20H15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a2e3b",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M15 21h30v20H15z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#1a2e3b",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    fill: "#fff",
    d: "M42 37H23"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1a2e3b",
    d: "M21 36.95l-3-1.73v3.46l3-1.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "player_svg__cls-2",
    d: "M31 20h-1.14A4 4 0 0022 21h-.5a2.5 2.5 0 00-2.5 2.5 2.5 2.5 0 002.5 2.5H31a3 3 0 003-3 3 3 0 00-3-3zM50 27h-1.14A4 4 0 0041 28h-.5a2.5 2.5 0 00-2.5 2.5 2.5 2.5 0 002.5 2.5H50a3 3 0 003-3 3 3 0 00-3-3z"
  })))));
}
export default SvgPlayer;